import styled from 'styled-components';
import { getSpace, getGridSpans, mq } from '../../../stylesheets/tools';

const StyledSearchTeaser = styled.div`
  .searchTeaser__link {
    display: block;
    position: relative;
    padding: ${getSpace('s')} 0;
    color: #fff;

    ${mq('m')} {
      padding: ${getSpace('xl')} 0;
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      height: 2px;
      background: #fff;
      ${getGridSpans('width', { s: 12, m: 8 })};
      ${getGridSpans('margin-left', { s: 0, m: [1, 'spread'] })}
    }

    &::-moz-focus-inner {
      border: 0;
    }
  }

  .searchTeaser__headline {
    margin-bottom: ${getSpace('s')};
  }

  .searchTeaser__content {
    ${getGridSpans('width', { s: 12, m: 8 })}
    ${getGridSpans('margin-left', { s: 0, m: [2, 'spread'] })}
    margin-bottom: ${getSpace('l')};
  }

  .searchTeaser__categories {
    margin-bottom: ${getSpace('m')};
  }
`;

export default StyledSearchTeaser;
